/**
 * Dispatches START_LOADING, waits for the browser to paint the overlay,
 * then executes the navigation callback. The double-rAF ensures at least
 * one full frame is painted before the route change tears out the old page.
 */
export const daggerNavigate = (callback) => {
  document.dispatchEvent(new CustomEvent("EVENTS.START_LOADING"))
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback()
    })
  })
}
